import { render, staticRenderFns } from "./deanInputSelectMultiBox.vue?vue&type=template&id=dbbf25c8&scoped=true"
import script from "./deanInputSelectMultiBox.vue?vue&type=script&lang=ts"
export * from "./deanInputSelectMultiBox.vue?vue&type=script&lang=ts"
import style0 from "./deanInputSelectMultiBox.vue?vue&type=style&index=0&id=dbbf25c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbf25c8",
  null
  
)

export default component.exports